module.exports = __webpack_public_path__ + "img/1529231367.076b7392.jpg";